import React from "react";

const Cargando = ({ mensaje }) => {
  return (
    <div className="d-flex justify-content-center">
      <div className="alert alert-success w-100 text-center" role="alert">
        {mensaje}
      </div>
    </div>
  );
};

export default Cargando;
